import { Activities, attraqtTracker } from './attraqtTracker';

function attraqtTrackerRemoveFromCart(fhProductCode: string): void {
  attraqtTracker({
    action: Activities.REMOVE_FROM_CART,
    target: {
      product: fhProductCode
    }
  });
}

export default attraqtTrackerRemoveFromCart;
